import React from "react";
import Container from "@/components/marketing/Container";
import MarqueeLogo from "@/components/marketing/MarqueeLogo";

const BASE = "https://media.base44.com/images/public/6a460432963500ce22897197/";

const LOGOS = [
  { name: "Reuters", src: BASE + "54195193d_Reuters_Logo_0.svg", scale: 0.9 },
  { name: "Khaleej Times", src: BASE + "75d098b96_Khaleej_Times_idhJr3h7da_1.svg" },
  { name: "Yahoo Finance", src: BASE + "289cccfa2_Yahoo_Logo_0.svg", scale: 0.9 },
  { name: "Arabian Business", src: BASE + "04500808a_Arabian_Business_transparent.png" },
  { name: "Business Insider", src: BASE + "4c3df51c1_Business_Insider_Logo_0.svg", scale: 1.15 },
  { name: "Gulf News", src: BASE + "23eb8ad36_Gulf_News_idd14Ts0hh_1.svg", scale: 1.1 },
  { name: "CNBC", src: BASE + "bb006c585_CNBC_Logo_0.svg", scale: 0.92 },
  { name: "Gulf Times", src: BASE + "eddcf9a73_Gulf_Times_id4wUweqCq_1.svg" },
  { name: "MarketWatch", src: BASE + "88aab5914_MarketWatch_Logo_0.svg", scale: 1.05 },
  { name: "Al Arabiya", src: BASE + "61d3ab794__idPFFswBEV_1.svg", scale: 1.6 },
  { name: "Financial Times", src: BASE + "b28cf37ed_Financial_Times_idRlWoph_N_1.svg" },
  { name: "Entrepreneur Middle East", src: BASE + "8d342355c_Entrepreneur_ME_transparent.png", scale: 1.3 },
  { name: "Digital Journal", src: BASE + "e48ced439_Digital_Journal_Logo_on_White_0.svg", scale: 1.4 },
];

export default function MediaLogos() {
  return (
    <section className="py-10 lg:py-12">
      <Container>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#8e8e96] text-center mb-6">
          Distributed to 1,700+ outlets including
        </p>
        <div className="overflow-hidden relative">
          <div className="flex w-max animate-ticker hover:[animation-play-state:paused] motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:animate-none">
            <div className="flex shrink-0 items-center gap-x-12 lg:gap-x-14 pr-12 lg:pr-14 motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:pr-0">
              {LOGOS.map((logo, i) => (
                <MarqueeLogo key={`a-${i}`} src={logo.src} name={logo.name} scale={logo.scale} />
              ))}
            </div>
            <div className="flex shrink-0 items-center gap-x-12 lg:gap-x-14 pr-12 lg:pr-14 motion-reduce:hidden" aria-hidden="true">
              {LOGOS.map((logo, i) => (
                <MarqueeLogo key={`b-${i}`} src={logo.src} name={logo.name} scale={logo.scale} />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}